export default  {
    LANGUAGE: "PFS_LANGUAGE_STORE",
}